import $ from 'jquery';
import Flickity from 'flickity';
import FLICKITY_ARROW_ICON from '../assets/flickityArrowIcon';

export default class HomeTestimonials {
  constructor(section) {
    this.$el = $(section.el);
    this.data = section.data;

    this.$slideshow = $('[data-testimonials-slideshow]', this.$el);
    this.$slides = $('[data-testimonials-slide]', this.$el);
    this.autoplay = this.data.should_autoplay
      && this.data.autoplay
      ? this.data.autoplay * 1000
      : false;

    this.$slideNavigation = this.$el.find('.dot');
    this.continueAutoplay = true;

    if (this.data.slide_count > 1) {
      this._initFlickity();
    }

    this._bindEvents();
  }

  _initFlickity() {
    this.flickity = new Flickity(this.$slideshow[0], {
      accessibility: true,
      arrowShape: FLICKITY_ARROW_ICON,
      autoPlay: this.autoplay,
      pageDots: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: true,
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.15
    });
  }

  _bindEvents() {
    if (this.data.slide_count > 1 && this.autoplay) {
      this._togglePaused(true);

      this.flickity.on('cellSelect', () => {
        if (this.continueAutoplay) {
          this.autoplayTimeout = 10000;
        } else {
          this.autoplayTimeout = 0;
        }

        this._togglePaused(false);
        this.continueAutoplay = true;

        setTimeout(() => {
          this.flickity.playPlayer();
          this._togglePaused(true);
        }, this.autoplayTimeout);
      });

      this.flickity.on('dragEnd', () => {
        this.continueAutoplay = false;
      });
    }
  }

  _unbindEvents() {
    this.$slides.off('focusin.slideshow');
  }

  _togglePaused(paused = true) {
    if (paused) {
      $('.is-selected', this.$el).addClass('is-paused');
    } else {
      $('.is-paused', this.$el).removeClass('is-paused');
    }
  }

  onSectionBlockSelect(block) {
    const $slides = $('[data-testimonials-slide]');
    const slideIndex = $slides.index($(block.el));

    if (!$(block.el).hasClass('is-selected')) {
      this.flickity.select(slideIndex, false, false);
    }

    if (this.autoplay) {
      this.continueAutoplay = false;
      this._togglePaused(false);
    }
  }

  onSectionBlockDeselect() {
    if (this.autoplay) {
      this._togglePaused(false);
      this.flickity.pausePlayer();
    }
  }

  onSectionUnload() {
    this.flickity.destroy();
    this._unbindEvents();
    this.modal.destroy();
  }
}
